import { createAction } from '@reduxjs/toolkit';

import { postAuth, putAuth } from '../../../services/AuthHttpService';
import { Organisation, OrganisationPost } from '../../../interfaces/organisation.interface';
import { fetchOrg, updateOrg } from '../../../services/DevPortalService';
import { AppThunk } from '../../store';
import { DEV_PORTAL_API_URL } from '../../../app-config';

export const getOrganisation = createAction<Organisation | undefined>('GET_ORG');
export const orgError = createAction<string>('ORG_ERROR');
export const resetOrganisation = createAction('RESET_ORG');

export function getOrganisationRedux(): AppThunk {
  return async (dispatch) => {
    try {
      const org = await fetchOrg();

      if (org && org.parsedBody) {
        return dispatch(getOrganisation(org.parsedBody));
      }
    } catch (e) {
      return dispatch(orgError('Error fetching Organisation'));
    }
  };
}

export const updateOrganisation =
  (id: string, body: any): AppThunk =>
  async (dispatch) => {
    try {
      const org = await updateOrg(body, id);

      if (org && org.parsedBody) {
        return dispatch(getOrganisation(org.parsedBody));
      }
    } catch (e) {
      return dispatch(orgError('Error updating Organisation'));
    }
  };

export function postOrganisationRedux(orgPost: OrganisationPost): AppThunk {
  return async (dispatch) => {
    try {
      const org = await postAuth<Organisation>(`${DEV_PORTAL_API_URL}/api/organisation`, orgPost);

      return dispatch(getOrganisation(org?.parsedBody));
    } catch (e) {
      return dispatch(orgError('Error creating Organisation'));
    }
  };
}

export function putOrganisationRedux(orgPut: Organisation): AppThunk {
  return async (dispatch) => {
    try {
      const org = await putAuth<Organisation>(`${DEV_PORTAL_API_URL}/api/organisation`, orgPut);

      return dispatch(getOrganisation(org?.parsedBody));
    } catch (e) {
      return dispatch(orgError('Error updating Organisation'));
    }
  };
}
